export default "__VITE_ASSET__B2uMcE5v__"